/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LogicStepParameterType {
  Primitive = 'Primitive',
  Object = 'Object',
  LogicStep = 'LogicStep',
  Options = 'Options',
  Select = 'Select',
  Tag = 'Tag',
  Lookup = 'Lookup',
  String = 'String',
  Text = 'Text',
  Boolean = 'Boolean',
  Integer = 'Integer',
  Decimal = 'Decimal',
  Date = 'Date',
  Enum = 'Enum',
  RelativeDate = 'RelativeDate',
  RelativeParty = 'RelativeParty',
  ApiSource = 'ApiSource',
  Answers = 'Answers'
}
